module.exports = __webpack_public_path__ + "static/media/Bio17.2bb738b0.png";